var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('content-navigation'),(_vm.iamNotificationsEnabled)?_c('i-a-m-pusher-handler'):_vm._e(),_c('processing-modal')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }